/* global mixpanel */
import {Component} from 'panel';
import {registerMPElement} from 'common/util/register-element';
import {getAlertDirection} from '../utils/common';
import {trackingProperties} from '../utils/tracking';

import template from './index.jade';
import css from './index.styl?inline';

class SmartHubDataPoint extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      alert: `json`,
      'alert-color': `string`,
      'explains-value': `string`,
      open: `boolean`,
      placement: `string`,
      'project-id': `string`,
      'utc-offset': `string`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        getAlertDirection: () => getAlertDirection(this.alert),
        getTooltipOffset: () => {
          const placement = this.attr(`placement`);
          if (placement === `top`) {
            return {left: this.offsetWidth / 2, top: 0};
          } else if (placement === `bottom`) {
            return {left: this.offsetWidth / 2, top: this.offsetHeight};
          } else if (placement === `left`) {
            return {left: 0, top: this.offsetHeight / 2};
          } else if (placement === `right`) {
            return {left: this.offsetWidth, top: this.offsetHeight / 2};
          } else {
            console.error(`Unsupported placement: ${placement}`);
          }
        },
        handleClick: () => {
          this.setAttribute(`open`, !this.attr(`open`));

          if (this.attr(`open`)) {
            this.trackClick();
          }
        },
        handleTooltipChange: (ev) => {
          if ([`open`, `closed`].includes(ev.detail.state)) {
            this.setAttribute(`open`, ev.detail.state === `open`);
          }
          this.helpers.handleEventPropagation(ev);
        },
        handleChangedAlert: (ev) => {
          this.setAttribute(`alert`, JSON.stringify(ev.detail.alert));
          this.helpers.handleEventPropagation(ev);
        },
        handleEventPropagation: (ev) => {
          ev.stopPropagation();
          this.dispatchEvent(new CustomEvent(ev.type, ev));
        },
      },
    };
  }

  get alert() {
    return this.attr(`alert`);
  }

  trackClick() {
    mixpanel.track(`Smart Hub: Clicked Data Point`, trackingProperties(this.alert));
  }
}

SmartHubDataPoint.SIZE = SmartHubDataPoint.prototype.SIZE = 16;

const BUFFER_SIZE = 20;
const CARET_SIZE = 10;
const TOOLTIP_MAX_WIDTH = 360;
// height is variable, but this is a reasonable max height based on 4 lines of text
const TOOLTIP_MAX_HEIGHT = 150;

SmartHubDataPoint.computePlacement = function(placements, {viewportTop, viewportLeft}) {
  const documentHeight = document.body.scrollHeight;
  const documentWidth = document.body.scrollWidth;
  const top = window.pageYOffset + viewportTop;
  const left = window.pageXOffset + viewportLeft;
  const placement = placements.find((placement) => {
    let tooltipTop, tooltipLeft;
    if (placement === `top`) {
      tooltipTop = top - TOOLTIP_MAX_HEIGHT - CARET_SIZE;
      tooltipLeft = left + this.SIZE / 2 - TOOLTIP_MAX_WIDTH / 2;
    } else if (placement === `bottom`) {
      tooltipTop = top + this.SIZE + CARET_SIZE;
      tooltipLeft = left + this.SIZE / 2 - TOOLTIP_MAX_WIDTH / 2;
    } else if (placement === `left`) {
      tooltipTop = top + this.SIZE / 2 - TOOLTIP_MAX_HEIGHT / 2;
      tooltipLeft = left - TOOLTIP_MAX_WIDTH - CARET_SIZE;
    } else if (placement === `right`) {
      tooltipTop = top + this.SIZE / 2 - TOOLTIP_MAX_HEIGHT / 2;
      tooltipLeft = left + this.SIZE + CARET_SIZE;
    } else {
      console.error(`Unsupported placement ${placement}`);
    }

    return (
      tooltipTop >= BUFFER_SIZE &&
      tooltipTop + TOOLTIP_MAX_HEIGHT + BUFFER_SIZE <= documentHeight &&
      tooltipLeft >= BUFFER_SIZE &&
      tooltipLeft + TOOLTIP_MAX_WIDTH + BUFFER_SIZE <= documentWidth
    );
  });

  if (!placement) {
    console.error(`Could not find valid placement, defaulting to first placement option`);
    return placements[0];
  }

  return placement;
};

export default registerMPElement(`mp-smart-hub-data-point`, SmartHubDataPoint);
